import LangEnum from '../../../lang/LangEnum';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../translation/TranslationContext';

const resolveGreetingLangKey = (hour: number) => {
  if (hour < 12) {
    return LangEnum.HOMEPAGE_GREETING_MORNING;
  }
  if (hour < 18) {
    return LangEnum.HOMEPAGE_GREETING_AFTERNOON;
  }
  return LangEnum.HOMEPAGE_GREETING_EVENING;
};

export const useHomeGreeter = () => {
  const { state } = useApplicationContext();
  const { translate } = useTranslation();

  const greetingLangKey = resolveGreetingLangKey(new Date().getHours());

  const greeting = translate(greetingLangKey, { user: state.user?.name });
  const subtitle = translate(LangEnum.HOMEPAGE_SUBTITLE);

  return { greeting, subtitle };
};
